// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"24931887","171":"6b473757","202":"7213f8f7","454":"2317b920","552":"d93c288e","952":"6d0770f1","960":"c8aac914"}[chunkId] + ".chunk.js";
};